import React, { Component } from 'react'
import classNames from 'classnames'
import ReactDatePicker from 'react-datepicker'

const Checkbox = props => (
    <input type="checkbox" {...props} className="d-none"/>
)

const CheckBoxWithBox = ({ id, checked, onChange, label }) => (
  <div className="d-flex align-items-center my-2">
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      className="custom-checkbox"
      style={{
        width: '20px',
        height: '20px',
        cursor: 'pointer',
        appearance: 'checkbox'
      }}
    />
    <label
      htmlFor={id}
      className="ml-2 mt-2"
      style={{ cursor: 'pointer', fontSize: '18px', color: '#333' }}
    >
      {label}
    </label>
  </div>
);

const TextField = props => (
  <div className="w-100 mx-auto mt-3">
    <label id="label" className="d-block"> {props.name}: </label>
    <input {...props} className="col-12 p-2" autoComplete='neasdfs'/>
  </div>
)


class DateInput extends React.Component {
  render() {
    const { value, onClick, handleChange } = this.props;
    return (
      <input 
        className="text-center form-control"
        onClick={onClick}
        style={{ fontSize: '20px' }}
        value={value}
        onChange={handleChange}
      />
    );
  }
}

export default class ProgramSurvey extends Component {
  state = {
    submitted: false,
    currentQuestionIndex: null,
    firstName: "",
    lastName: "",
  }

  scrollToTop = (type="smooth") => {
    if(this.statusBar || true) {
      this.statusBar.scrollIntoView({ behavior: type });
    }
  }

  componentWillMount(){
    const residentName = !!this.props.resident ? {
      firstName: this.props.resident.first_name,
      lastName: this.props.resident.last_name,
      residentKey: !!this.props.resident ? this.props.resident.id : null,
      residentToken: !!this.props.resident ? this.props.resident.uuid : null,
      requestKey: !!this.props.survey_request ? this.props.survey_request.id : null,
      requestToken: !!this.props.survey_request ? this.props.survey_request.uuid : null
    } : {
      firstName: '',
      lastName: ''
    }
    
    const currentQuestionIndex = this.props.survey.slug === 'participant_satisfaction' ? 0 : this.props.resident ? 0 : null;
    
    this.setState({
      resident: this.props.resident,
      survey_request: this.props.survey_request,
      survey: {
        ...this.props.survey,
        questions: this.props.survey.questions.sort((a, b) => a.number - b.number).map((question) => {
          return {
            ...question,
            choices: question.choices.sort((a, b) => a.number - b.number)
          }
        })
      },
      ...residentName,
      currentQuestionIndex,
    })
  }

  submitForm(data) {
    $.ajax(`/client_surveys/${data.slug}/submissions.json?token=${this.props.organizationToken}`, {
      method: 'POST',
      data: data
    }).then(response => {
      this.setState({currentQuestionIndex: this.state.currentQuestionIndex + 1})
    })
  }

  nextPressed(){
    const { currentQuestionIndex, firstName, lastName, survey, residentKey, residentToken, requestKey, requestToken} = this.state
    const { questions } = this.state.survey

    if (questions[currentQuestionIndex].kind === 'checkbox') {
      const checkbox = document.getElementById(`checkbox-${currentQuestionIndex}`);

      if (checkbox) {
        questions[currentQuestionIndex].number = checkbox.checked ? 1 : 0;
      }
    }

    if (currentQuestionIndex != (questions.length - 1)){
      this.setState({
        currentQuestionIndex: currentQuestionIndex + 1
      })
    } else {
      var data = {
        survey_id: survey.id,
        slug: survey.slug,
        first_name: firstName,
        last_name: lastName,
        responses: [],
        resident_key: residentKey,
        resident_token: residentToken,
        request_key: requestKey,
        request_token: requestToken,
      }
      
      if (survey.slug === 'participant_satisfaction') {
        const name = questions[0]?.text || '';
        const [first, ...last] = name.split(' ');
      
        data.first_name = first || '';
        data.last_name = last.join(' ') || '';
      }
      questions.map((question) =>{
        data.responses.push({
          question_id: question.id,
          number: question['number'],
          date: question['date'],
          text: question.kind === 'multiple_free_response' ? question.response.join('\n ')  : question['text'],
          bool: question['bool'],
          choice_id: question.choice
        })
      })
      this.setState({ submitted: true })
      this.submitForm(data)
    }
    this.scrollToTop()
    window.scrollTo(0, 0)
  }

  getPercentage(){
    const { currentQuestionIndex } = this.state
    const { questions } = this.state.survey
    var number = ( (currentQuestionIndex) / questions.length ) * 100
    return `${number}%`
  }

  selectAnswer(questionIndex, responseValue, selectedNumber = 0) {
    let question = this.state.survey.questions[questionIndex];
    let answerKind = question.answer_kind;
    if (question.kind === 'multiple_free_response') {
      if (!Array.isArray(question.response)) {
        question.response = [];
      }   
      question.response[selectedNumber] = responseValue;
    } else {
      question[answerKind] = responseValue;
      question.response = responseValue;
      question.choice = selectedNumber;
    }
  
    this.forceUpdate();
  }
  

  checkIfButtonEnabled() {
    const { currentQuestionIndex } = this.state;
    const { questions, slug } = this.state.survey;

    if (
      currentQuestionIndex === 0 &&
      (slug === 'participant_satisfaction' || slug === 'rci_36')
    ) {
      return false;
    }

    const currentQuestion = questions[currentQuestionIndex];

    return currentQuestion.required && currentQuestion.response === undefined;
  }

  handleChange(obj) {
    this.setState(obj);
  }

  checkIfInfoEntered(){
    const {firstName, lastName} = this.state

    return(((firstName.length > 0) && (lastName.length > 0)) ? false : true)
  }

  render() {
    const { currentQuestionIndex, surveyName, submitted, survey } = this.state
    const { questions } = this.state.survey

    return (
      <div id="program_survey" className="w-100 h-100">
        <div className="bg-infos" ref={(rr) => { this.statusBar = rr }} style={{backgroundColor: 'rgba(0, 127, 255, 1)', height: 8, width: this.getPercentage(), transition: '0.2s ease 0.1s'}}/>
        <div className="d-flexs" style={{height: "calc(100% - 16px)", backgroundColor: '#FAFAFA'}}>
          { currentQuestionIndex == null ? 
            <div className="d-flex h-100">
              <div className="col-12 my-auto">
                <h3 className='text-center' id="title"> { survey.name } </h3>
                <hr className="m-0 mx-auto mt-2" style={{ width: "30%" }} />
                { survey.slug == 'peer_support_session' ?
                  <p id="subtitle" className="text-center p-4 mt-1">Enter Participant Name</p>
                  :  <p id="subtitle" className="text-center p-4 mt-1">Please enter your information below before continuing.</p>
                }
                <div className="col-xs-12 col-md-6 mx-auto mt-5">
                  <TextField
                   name="First Name"
                   value={this.state.firstName}
                   onChange={(e)=>this.handleChange({firstName: e.target.value})}
                  />
                  <TextField 
                   name="Last Name"
                   value={this.state.lastName}
                   onChange={(e)=>this.handleChange({lastName: e.target.value})}
                  />
                  {!this.checkIfInfoEntered() &&
                    <button
                     type="button"
                     disabled={this.checkIfInfoEntered()}
                     className={classNames("button", "w-100", "mt-4", "p-2", "font-weight-bold", {
                        "button-active": !this.checkIfInfoEntered(),
                        "bg-secondary": this.checkIfInfoEntered(),
                       })}
                     onClick={()=>this.setState({currentQuestionIndex: 0})}
                    >NEXT</button>
                  }
                </div>
              </div>
            </div>
            : <form className="col-12 pl-0">
              <div className="h-100 my-auto d-flex flex-column">
                <p className="text-right p-3"><i>{surveyName}</i></p>
                {
                  questions.map((question, questionIndex) => (
                    <div 
                     key={questionIndex} 
                     className={classNames("d-flex-column", "justify-content-between", "mt-5", "my-auto", "col-xs-12", "col-md-6", "mx-auto", {"d-none" : questionIndex != currentQuestionIndex})}>
                      <div>
                        <h3 className='text-center' id="title">{question.body}</h3>
                        <hr className="m-0 mx-auto mt-2" style={{ width: "30%" }} />
                        <p className="text-center p-0 mt-1">
                          <small>{question.description}</small>
                        </p>
                      </div>
                      <div className="mt-5">
                      {
                        (question.kind == 'boolean' || question.kind == 'boolean_with_na') &&
                        <>
                          <label className="d-block">
                            <Checkbox
                              checked={ true == question.response }
                              onClick={ () => this.selectAnswer(questionIndex, true) }
                              style={{ cursor: 'pointer' }}/>
                          </label>
                          <h5 
                            onClick={()=>this.selectAnswer(questionIndex, true)} 
                            className={classNames("p-3 text-center",{"question-active": true == question.response})}
                            style={{cursor: 'pointer', fontWeight: 300, color: '#6f6f6f', }}>
                            Yes
                          </h5>
                          <label className="d-block">
                            <Checkbox
                              checked={ false == question.response }
                              onClick={ () => this.selectAnswer(questionIndex, false) }
                              style={{ cursor: 'pointer' }}/>
                          </label>
                          <h5 
                            onClick={()=>this.selectAnswer(questionIndex, false)} 
                            className={classNames("p-3 text-center",{"question-active": false === question.response})}
                            style={{cursor: 'pointer', fontWeight: 300, color: '#6f6f6f', }}>
                            No
                          </h5>
                          {
                            question.kind == 'boolean_with_na' &&
                            <>
                              <label className="d-block">
                                <Checkbox
                                  checked={ false == question.response }
                                  onClick={ () => this.selectAnswer(questionIndex, null) }
                                  style={{ cursor: 'pointer' }}/>
                              </label>
                              <h5 
                                onClick={()=>this.selectAnswer(questionIndex, null)} 
                                className={classNames("p-3 text-center",{"question-active": null === question.response})}
                                style={{cursor: 'pointer', fontWeight: 300, color: '#6f6f6f', }}>
                                N/A
                              </h5>
                            </>
                          }
                        </>
                      }
                      {
                          question.kind == 'multiple_choice' &&
                          question.choices.map((choices, choicesIndex) => (
                            <div key={choicesIndex} className="d-flex justify-content-center">
                              <label className="d-block">
                                <Checkbox
                                  checked={choices.number == question.choice}
                                  onClick={()=>this.selectAnswer(questionIndex, choices.value, choices.number)}
                                  style={{cursor: 'pointer'}}
                                />
                              </label>
                              <h5 
                                onClick={()=>this.selectAnswer(questionIndex, choices.value, choices.number)} 
                                className={classNames("p-3",{"question-active": choices.number == question.choice})}
                                style={{cursor: 'pointer', fontWeight: 300, color: '#6f6f6f', }}>
                                {choices.body}
                              </h5>
                            </div>
                          ))
                        }
                        {
                          question.kind === 'checkbox' &&
                          question.choices.map((choices, choicesIndex) => (
                            <CheckBoxWithBox
                              key={choicesIndex}
                              id={`checkbox-${questionIndex}`}
                              onChange={() => this.selectAnswer(questionIndex, choices.value, choices.number)}
                              label={choices.body}
                            />
                          ))
                        }
                        {
                          question.kind == 'multiple_choice_text' &&
                          question.choices.map((choices, choicesIndex) => (
                            <div key={choicesIndex} className="d-flex justify-content-center">
                              <label className="d-block">
                                <Checkbox
                                  checked={choices.body == question.response}
                                  onClick={()=>this.selectAnswer(questionIndex, choices.body)}
                                  style={{cursor: 'pointer'}}
                                />
                              </label>
                              <h5 
                                onClick={()=>this.selectAnswer(questionIndex, choices.body)} 
                                className={classNames("p-3",{"question-active": choices.body == question.response})}
                                style={{cursor: 'pointer', fontWeight: 300, color: '#6f6f6f', }}>
                                {choices.body}
                              </h5>
                            </div>
                          ))
                        }
                        {
                          question.kind == 'number' &&
                          <div className="row">
                            <div className="col-sm-6 mx-auto">
                              <input
                                type="number"
                                className="form-control"
                                onChange={(e) => this.selectAnswer(questionIndex, e.target.value)} />
                            </div>
                          </div>
                        }
                        {
                          question.kind == 'paragraph' &&
                          <div className="row">
                            <div className="col-sm-6 mx-auto">
                            <textarea
                              className="form-control"
                              rows="4"
                              onChange={(e) => this.selectAnswer(questionIndex, e.target.value)}
                            ></textarea>
                            </div>
                          </div>
                        }
                        {
                          question.kind == 'multiple_free_response' &&
                          question.choices.map((choices, choicesIndex) => (
                            <div key={choicesIndex} className="row pt-5">
                              <div className="col-sm-6 mx-auto">
                                <p>{`${choicesIndex + 1}.`}</p>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={question.response?.[choicesIndex] || ""}
                                  onChange={(e) =>
                                    this.selectAnswer(questionIndex, e.target.value, choicesIndex)
                                  }
                                />
                              </div>
                            </div>
                          ))
                        }
                        {
                          question.kind == 'free_response' && !(currentQuestionIndex === 0 && survey.slug === 'rci_36') &&
                          <div className="row">
                            <div className="col-sm-6 mx-auto">
                              <input
                                type="text"
                                className="form-control"
                                onChange={(e) => this.selectAnswer(questionIndex, e.target.value)} />
                            </div>
                          </div>
                        }
                        {
                          question.kind == 'datetime' &&
                          <div className="row">
                            <div className="col-sm-6 mx-auto text-center">
                              <ReactDatePicker
                                selected={question['date'] ? moment(question['date']) : null}
                                onChange={newDate => this.selectAnswer(questionIndex, moment(newDate).format('YYYY-MM-DD'))}
                                dateFormat="LL"
                                customInput={<DateInput date={question['date']} handleChange={newDate => this.selectAnswer(questionIndex, moment(newDate).format('YYYY-MM-DD'))}/>}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  ))
                }
                <div className="d-flex h-100">
                  <div
                   key={questions.length}
                   className={classNames("mt-5", "col-xs-12", "col-md-8", "my-auto", "mx-auto", {"d-none" : questions.length != currentQuestionIndex})}>
                    <h3 id="title" className='text-center'> Your survey has been received. </h3>
                    <hr className="m-0 mx-auto mt-2" style={{ width: "30%" }} />
                    <p className="text-center p-0 mt-1"><small>Thank You. You may now close this window.</small></p>
                  </div>
                </div>
                { 
                  (currentQuestionIndex < questions.length && !this.checkIfButtonEnabled()) && 
                  <div className="w-100 text-center">
                    <button
                     disabled={ this.checkIfButtonEnabled() }
                     type='button'
                     className={classNames("button", "m-4", "col-6", "p-2", "font-weight-bold", "mt-4", "mx-auto", {
                      "button-active": !this.checkIfButtonEnabled(),
                      "bg-secondary": this.checkIfButtonEnabled(),
                      "d-none": submitted
                     })}
                     onClick={() => this.nextPressed()}>
                      { (currentQuestionIndex == (questions.length - 1)) ? 'SUBMIT' : "NEXT"}
                    </button> 
                  </div>
                }
                { 
                    // replace with a loading spinner when I figure out how to import packages to rails-react
                  submitted && (currentQuestionIndex < questions.length) && (<p className="text-center">Submitting...</p>)
                }
              </div>
            </form> 
          }
        </div>
      </div>
    )
  }
}
